import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from '../../components/Breadcrumb';
import SingleBlog from '../../components/Blog';

const BlogMain = () => {
  const [events, setEvents] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('https://ricgop.online/api/eventz.php')
      .then(res => {
        console.log("Response status: ", res.status);
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then(data => {
        console.log("Fetched data: ", data);

        const rawEvents = Array.isArray(data.events)
          ? data.events
          : Array.isArray(data)
          ? data
          : [];

        const excludedIds = [5, 6, 7, 8];
        const filteredEvents = rawEvents.filter(
          event => !excludedIds.includes(parseInt(event.id))
        );

        setEvents(filteredEvents);
      })
      .catch(err => {
        console.error('Error fetching events:', err);
        setError('Failed to load events. Please try again later.');
      });
  }, []);

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <main>
      <Breadcrumb title="Events" />
      <div className="it-blog-area fix pt-120 pb-90">
        <div className="container">
          <div className="row">
            {events.map((event, index) => (
              <div
                key={event.id}
                className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay={`${0.3 + index * 0.2}s`}
              >
                <Link to={`/blog-details/${event.id}`}>
                  <SingleBlog
                    id={event.id}
                    blogImage={`/assets/img/${event.image_url}`} // ✅ Now a plain string
                    publishedDate={event.published_date}
                    publishedMonth={event.published_month}
                    authorName={event.author_name}
                    title={event.title}
                    btnText="Read More"
                  />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
};

export default BlogMain;
